import { AccountDetailsComponent } from './account-details/account-details.component';
import { AccountSignatureComponent } from './account-signature/account-signature.component';
import { ChipComponent } from './chip/chip.component';
import { ClientSupportComponent } from './client-support/client-support.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ErrorComponent } from './error/error.component';
import { FileUploadButtonComponent } from './file-upload';
import {
  AttachmentSizeDisplayComponent,
  CommentDialogEditComponent,
  CustomCheckboxEditComponent,
  DecimalDisplayComponent,
  NotApplicableDisplayComponent,
  TimeDisplayComponent,
  TimeEditComponent,
  ConfigurationBadgeDisplayComponent,
} from './grid';
import { HorizontalNavigationComponent } from './horizontal-navigation/horizontal-navigation.component';
import { LoaderComponent } from './loader/loader.component';
import { ModulePickerComponent } from './module-picker/module-picker.component';
import { NgbTimePickerComponent } from './ngb-timepicker/ngb-timepicker.component';
import { SearchableSelectComponent } from './searchable-select/searchable-select.component';
import { SearchableSelectFormControlComponent } from './searchable-select-form-control/searchable-select-form-control.component';
import { StyleGuideComponent } from './style-guide/style-guide.component';
import { SubprojectPickerComponent } from './subproject-picker/subproject-picker.component';
import { UnsavedChangesDialogComponent } from './unsaved-changes-dialog/unsaved-changes-dialog.component';
import { UnsavedChangesComponent } from './unsaved-changes/unsaved-changes.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { SectionTitleComponent } from './section-title/section-title.component';
import { TimeComponent } from './time/time.component';
import { AttachmentsUploadComponent } from './attachments-upload/attachments-upload.component';
import { MultiselectComponent } from './multiselect/multiselect.component';
import { UserPreferencesDialogComponent } from './user-preferences-dialog/user-preferences-dialog.component';
import { SelectClientDialogComponent } from './client-picker-dialog/client-picker-dialog.component';

export {
  ConfirmDialogComponent,
  StyleGuideComponent,
  NgbTimePickerComponent,
  ModulePickerComponent,
  ErrorComponent,
  AccountDetailsComponent,
  AccountSignatureComponent,
  ClientSupportComponent,
  UnsavedChangesDialogComponent,
  SubprojectPickerComponent,
  LoaderComponent,
  ChipComponent,
  HorizontalNavigationComponent,
  CommentDialogEditComponent,
  TimeEditComponent,
  TimeDisplayComponent,
  DecimalDisplayComponent,
  SearchableSelectComponent,
  SearchableSelectFormControlComponent,
  UnsavedChangesComponent,
  NotApplicableDisplayComponent,
  CustomCheckboxEditComponent,
  AttachmentSizeDisplayComponent,
  PageNotFoundComponent,
  SectionTitleComponent,
  TimeComponent,
  AttachmentsUploadComponent,
  MultiselectComponent,
  ConfigurationBadgeDisplayComponent,
  UserPreferencesDialogComponent,
  SelectClientDialogComponent,
};

export const components = [
  ConfirmDialogComponent,
  StyleGuideComponent,
  NgbTimePickerComponent,
  ModulePickerComponent,
  ErrorComponent,
  AccountDetailsComponent,
  AccountSignatureComponent,
  ClientSupportComponent,
  UnsavedChangesDialogComponent,
  SubprojectPickerComponent,
  LoaderComponent,
  FileUploadButtonComponent,
  ChipComponent,
  HorizontalNavigationComponent,
  CommentDialogEditComponent,
  TimeEditComponent,
  TimeDisplayComponent,
  DecimalDisplayComponent,
  SearchableSelectComponent,
  SearchableSelectFormControlComponent,
  UnsavedChangesComponent,
  NotApplicableDisplayComponent,
  CustomCheckboxEditComponent,
  AttachmentSizeDisplayComponent,
  PageNotFoundComponent,
  SectionTitleComponent,
  TimeComponent,
  AttachmentsUploadComponent,
  MultiselectComponent,
  ConfigurationBadgeDisplayComponent,
  UserPreferencesDialogComponent,
  SelectClientDialogComponent,
];
